// extracted by mini-css-extract-plugin
export default {"formElement":"EditExpenseForm_formElement__pOKx1","actionBtn":"EditExpenseForm_actionBtn__Gv8M3"};